import * as alwaysInCacheTableIdList from './alwaysInCacheTableIdList';
import { getFolderChangeDigestAction } from 'owa-mail-focused-inbox-rollup-store';
import { isFocusedInboxEnabled } from 'owa-mail-list-actions/lib/utils/FocusedInboxUtil';
import { getInboxTableView } from 'owa-mail-table-loading-actions';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import { isInboxPlusEnabled } from 'owa-inbox-plus-util/lib/util/inboxPlusFlightUtil';

export default function updateAlwaysInCacheTableIds(): number {
    const isFocusedOtherEnabled = isFocusedInboxEnabled();
    const regularInboxTableView = getInboxTableView(
        FocusedViewFilter.None,
        InboxClassificationFilter.None
    );
    const focusedInboxTableView = getInboxTableView(
        FocusedViewFilter.Focused,
        InboxClassificationFilter.Focused
    );
    const otherInboxTableView = getInboxTableView(
        FocusedViewFilter.Other,
        InboxClassificationFilter.Other
    );

    // If Focused / Other is enabled and Focused table view is not in the always in cache table, add it and Other
    // Else if Focused / Other is NOT enabled and the regular inbox table view is not in the always in cache table, add it
    if (isFocusedOtherEnabled) {
        alwaysInCacheTableIdList.remove(regularInboxTableView);
        alwaysInCacheTableIdList.add(focusedInboxTableView);
        alwaysInCacheTableIdList.add(otherInboxTableView);

        // VSO 13075: Read focused/other rollup data from session data response on boot
        // Making this additional request to get folder change digest for now
        if (!isInboxPlusEnabled()) {
            getFolderChangeDigestAction(otherInboxTableView);
        }
    } else {
        alwaysInCacheTableIdList.remove(focusedInboxTableView);
        alwaysInCacheTableIdList.remove(otherInboxTableView);
        alwaysInCacheTableIdList.add(regularInboxTableView);
    }

    return 0;
}
